"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_2 = require("react");
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var useLevelUp = function () {
    var openLevelUp = (0, apps_shared_1.useOpenLevelUp)();
    var prevUserLevel = (0, react_1.useRef)(null);
    var currentLevelInfo = (0, swr_hooks_1.usePlayerStatus)().currentLevelInfo;
    (0, react_2.useEffect)(function () {
        if (!prevUserLevel.current &&
            prevUserLevel.current !== 0 &&
            ((currentLevelInfo === null || currentLevelInfo === void 0 ? void 0 : currentLevelInfo.level) || (currentLevelInfo === null || currentLevelInfo === void 0 ? void 0 : currentLevelInfo.level) === 0))
            prevUserLevel.current = Number((currentLevelInfo === null || currentLevelInfo === void 0 ? void 0 : currentLevelInfo.level) || 0);
        if ((prevUserLevel.current || prevUserLevel.current === 0) &&
            ((currentLevelInfo === null || currentLevelInfo === void 0 ? void 0 : currentLevelInfo.level) || (currentLevelInfo === null || currentLevelInfo === void 0 ? void 0 : currentLevelInfo.level) === 0) &&
            Number((currentLevelInfo === null || currentLevelInfo === void 0 ? void 0 : currentLevelInfo.level) || 0) === Number(prevUserLevel.current) + 1) {
            openLevelUp();
            prevUserLevel.current = Number((currentLevelInfo === null || currentLevelInfo === void 0 ? void 0 : currentLevelInfo.level) || 0);
        }
    }, [openLevelUp, prevUserLevel, currentLevelInfo]);
    (0, react_2.useEffect)(function () {
        return function () {
            prevUserLevel.current = null;
        };
    }, []);
};
exports.default = useLevelUp;
